export default "__VITE_ASSET__711d9b55__"